import { Entity, Field } from "typegraph";

@Entity({one: "tag", many: "tags"})
export default class Tag {

	@Field()
	public name;

}



// WEBPACK FOOTER //
// ./src/panels/subscriptionTags/entities/Tag.ts